'use strict';

var angularModule = angular.module('t2g.common.services.datePickerSettings', []);

module.exports = angularModule;

angularModule.factory('DatepickerSettings', function() {
  return {
    default: {
      onOpenFocus: true,
      showWeeks: false,
      formatMonth: 'MMM',
      monthColumns: 4,
      startingDay: 1,
      closeOnDateSelection: true,
      closeText: 'OK',
    },
    minMonth: {
      closeOnDateSelection: true,
      onOpenFocus: true,
      showWeeks: false,
      formatMonth: 'MMM',
      monthColumns: 4,
      startingDay: 1,
      minMode: 'month',
      closeText: 'OK',
    },
  };
});



// WEBPACK FOOTER //
// ./src/app/common/services/DatepickerSettingsService.js